import Base from './Base';
import { parsePhoneNumber } from 'libphonenumber-js';
import Phone from './Phone';
import Phones from './../collections/Phones';
import organization from './../modules/organization';
import { TYPES_INBOX } from '../modules/user';

export default class Inbox extends Base {
    constructor(item) {
        super(item);

        if (item.number) {
            this.number = new Phone(item.number);
        }

        if (Array.isArray(item.numbers)) {
            this.numbers = new Phones(item.numbers).models;
        } else {
            this.numbers = [];
        }
    }

    get color() {
        const palette = [
            '#6372A5',
            '#1D95F2',
            '#10D0AD',
            '#E13466',
            '#FFC422',
            '#FF9423',
            '#A233E1',
        ];

        return palette[this.id % palette.length];
    }

    get isToolFreeNumbers() {
        return Boolean(this.numbers.filter(item => item.isTollFree).length);
    }

    get isOnlyAllTollFreeNumbers() {
        let tollFreeNumbersLength = this.numbers.filter(item => item.isTollFree).length;

        return this.numbers.length === tollFreeNumbersLength;
    }

    get key() {
        if (this.is_favorite) {
            return 'onFavorite';
        }
        return this.id ? 'shared' : 'unified';
    }

    get inboxId() {
        return this.id || 0;
    }

    get inboxType() {
        if (this.is_smart) return TYPES_INBOX.SMART;

        return this.id ? TYPES_INBOX.SHARED : TYPES_INBOX.UNIFIED;
    }

    get isGroupInbox() {
        return this.inboxType === TYPES_INBOX.GROUP;
    }

    get isUnifiedInbox() {
        return this.inboxType === TYPES_INBOX.UNIFIED;
    }

    get isSmartInbox() {
        return this.inboxType === TYPES_INBOX.SMART;
    }

    get isSharedInbox() {
        return this.inboxType === TYPES_INBOX.SHARED;
    }

    get isToolFreeNumber() {
        return Boolean(this.number?.isTollFree);
    }

    get isLocalNumber() {
        return Boolean(!this.number?.isTollFree);
    }

    get isAircallNumber() {
        return Boolean(this.number?.isAircall);
    }

    get isShortCode() {
        return Boolean(this.number?.isShortCode);
    }

    get formattedNumber() {
        return this.number?.formattedNumber || '';
    }

    get isStatusDeclinedNumbers() {
        return Boolean(this.numbers.filter(item => item.statusDeclined).length);
    }

    get isStatusUnverifiedNumbers() {
        return Boolean(this.numbers.filter(item => item.statusUnverified).length);
    }

    get isStatusTollFreeUnverifiedNumbers() {
        return Boolean(this.numbers.filter(item => item.isTollFree && item.statusUnverified).length);
    }

    get isTollFreeNumbers() {
        return Boolean(this.numbers.filter(item => item.isTollFree).length);
    }

    get checkIsAirCallNumbers() {
        return Boolean(this.numbers.filter(item => item.isAircall).length);
    }

    get formatNumber() {
        return this.number?.number || '';
    }

    get numberOrCount() {
        if (this.numbersCount > 1) {
            return `${this.numbersCount} numbers`;
        }

        return this.number ? this.number?.formattedNumber || '' : '';
    }

    get fullNameNumberable() {
        return this.name || 'Unnamed Inbox';
    }

    get phoneNumberFormatted() {
        return parsePhoneNumber(this.number?.number || '', 'US').nationalNumber;
    }

    get isRCS() {
        return this.is_rcs;
    }

    get isSmart() {
        return this.is_smart;
    }

    get isGeomatch() {
        return this.is_geomatch;
    }

    get isNumberUseOrganizationSettings() {
        return Boolean(this.number?.use_organization_call_settings);
    }

    get isNumberOutboundCalls() {
        if (this.isNumberUseOrganizationSettings) return organization.state.organization.organization_call.is_active;

        return Boolean(this.number?.voice_outbound);
    }

    get isNumberInboundCalls() {
        if (this.isNumberUseOrganizationSettings) return organization.state.organization.organization_call.is_active_inbound;

        return Boolean(this.number?.voice);
    }

    get isLocalNumbersGroup() {
        return Boolean(!this.isSmart && this.number?.isLocal) || (this.number?.isLocal) || (!this.isSmart && this.isAircallNumber);
    }

    get isStatusTollFreeVerified() {
        return Boolean(this.number?.statusTollFreeVerified);
    }

    get isStatusTollFreeUnverified() {
        return Boolean(!this.number?.statusTollFreeVerified);
    }

    get isVoicemail() {
        return Boolean(this.voicemail);
    }

    get isTranscribeVoiceToText() {
        if (!this.isVoicemail) return false;

        return Boolean(this.number?.is_transcribe_voice_to_text);
    }

    get isPFTInbox() {
        return this.number?.number_vendor?.key === 'inteliquent';
    }

    get isMuted() {
        return this.is_muted;
    }
}
